import { AgGridColumnProps } from "ag-grid-react";


export const PurchaseOrderComponentTableColumns: AgGridColumnProps[] = [
    {
        headerName: "Line Item #",
        field: "lineItemNumber",
        cellEditor: "NumberWithoutDecimalEditor",
        checkboxSelection: true
    },
    {
        headerName: "Part #",
        field: "partNumber"
    },
    {
        headerName: "Description",
        field: "description"
    },
    {
        headerName: "Quantity",
        field: "quantity",
        cellEditor: "NumberWithoutDecimalEditor"
    },
    {
        headerName: "Quantity Unit",
        field: "quantityUnit",
        cellEditor:'SelectUnitEditor'
    },
    {
        headerName: "Unit Price",
        field: "unitPrice",
        cellEditor: "NumberWithDecimalEditor"
    },
    {
        headerName: "Total Value",
        field: "totalValue",
        editable : false,
        cellEditor: "NumberWithDecimalEditor",
        valueGetter: params => {
            params.data.totalValue = (params.data.unitPrice * params.data.quantity).toFixed(2);
            return params.data.totalValue;
        }
    }
]
